import {
  Box,
  Disclaimer,
  Div,
  H5,
  ReceivablesAging,
  displayCentsInDollars,
  lightTheme,
} from '@vgrubs/components';

type Props = {
  aging: ReceivablesAging;
};

/**
 * Open items by how long they have been open. The bars are scaled to the
 * largest bucket, not to the total, so a small old bucket still shows.
 */
export const ReceivablesAgingCard = ({ aging }: Props) => {
  // Older reads as more urgent: yellow through to red.
  const buckets = [
    { label: '0-30 days', amount: aging.days0To30, color: lightTheme.yellow },
    { label: '31-60 days', amount: aging.days31To60, color: lightTheme.orange },
    {
      label: '61-90 days',
      amount: aging.days61To90,
      color: lightTheme.primary,
    },
    { label: '90+ days', amount: aging.days90Plus, color: lightTheme.darkGray },
  ];
  const largest = Math.max(...buckets.map((bucket) => bucket.amount), 1);

  return (
    <Box $flex $column $gap="16px">
      <Div>
        <H5 $m="0">Open charges by age</H5>
        <Disclaimer $m="0" $color={lightTheme.lightGray}>
          The reserve used is a balance, not a charge, so it is not counted
          here.
        </Disclaimer>
      </Div>
      <Div
        $grid
        $gridTemplateColumns="repeat(auto-fit, minmax(140px, 1fr))"
        $gap="16px"
      >
        {buckets.map((bucket) => (
          <Div key={bucket.label} $flex $column $gap="6px">
            <Disclaimer $m="0">{bucket.label}</Disclaimer>
            <H5 $m="0">{displayCentsInDollars(bucket.amount)}</H5>
            {/* Div resets height to auto on phones, hence the SM twin. */}
            <Div
              $height="6px"
              $heightSM="6px"
              $borderRadius="3px"
              $background={lightTheme.gray}
              $overflow="hidden"
            >
              <Div
                $height="100%"
                $heightSM="100%"
                $width={`${(bucket.amount / largest) * 100}%`}
                $background={bucket.color}
              />
            </Div>
          </Div>
        ))}
      </Div>
    </Box>
  );
};
